<template>
    <vue-custom-scrollbar id="workspace-result-materials" class="workspace-module-container">
        <div id="projects-table-label">Список товаров</div>
        <div class="result-label-project-name">
            <span class="text-project">Проект: </span>
            <span class="name-project bold-text">{{projectName}}</span>
        </div>
        <div id="projects-table-container">
            <table class="result-table">
                <thead>
                <tr class="head-tr">
                    <th class="field-number">№</th>
                    <th>Изображение</th>
                    <th>Название</th>
                    <th>Количество</th>
                    <th>Цена</th>
                    <th>Итог</th>
                    <th class="field-edit"></th>
                </tr>
                </thead>
                <tbody>
                <tr class="body-tr row" v-for="(product, index) in productsCost">
                    <td>
                        <span class="table-data-central">{{index + 1}}</span>
                    </td>
                    <td>
                        <img class="result-material-img" :src="urlForPhoto(product.src)"/>
                    </td>
                    <td>
                        <span class="table-data">{{product.name}}</span>
                    </td>
                    <td>
                        <span class="table-data">{{product.area}} {{getDimensionByType(product.type)}}</span>
                    </td>
                    <td>
                        <span class="table-data">{{product.price.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}} ₽/м²</span>
                    </td>
                    <td>
                        <span class="table-data">{{product.cost.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ')}} ₽</span>
                    </td>
                    <td>
                        <div class="table-svg-button" v-on:click="deleteRow(product.productUUID)">
                            <SVGAdminDeleteRow class="table-svg-delete"/>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import {urlForStaticVue} from "../common";
    import SVGAdminDeleteRow from "../SVG/SVGAdminDeleteRow";

    export default {
        name: "WorkspaceResultMaterials",
        mixins: [urlForStaticVue],
        components: {
            SVGAdminDeleteRow,
            vueCustomScrollbar
        },
        computed: {
            projectName(){
                return this.$store.getters["active/NAME"];
            },
            productsCost() {
                return this.$store.getters["cost/PRODUCTS_COST"];
            },
        },
        methods: {
            urlForPhoto(url) {
                return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
            },
            deleteRow(productUUID) {
                this.$store.commit('cost/DELETE_PRODUCT_FROM_COST', productUUID);
            },
            getDimensionByType(type) {
                if (type === 'wall') {
                    return 'м²'
                } else if (type === 'additional') {
                    return 'пог. м'
                } else {
                    return ''
                }

            }
        }
    }
</script>

<style scoped>
    #workspace-result-materials {
        padding: 50px 0 0 40px;
        background-color: #F2F2F2;
        user-select: none;
        box-sizing: border-box;
    }

    #projects-table-label {
        font-size: 32px;
        font-weight: bold;
        color: #303030;
    }

    #projects-table-container {
        width: auto;
        height: auto;
        margin-right: 40px;
        margin-bottom: 40px;
        background-color: white;
        padding: 40px;
        border-radius: 4px;
        box-sizing: border-box;
    }

    .result-label-project-name {
        color: #303030;
        margin: 15px 0;
    }

    .result-material-img {
        /*max-width: 150px;*/
        /*max-height: 150px;*/
        width: 150px;
        height: 75px;
        object-fit: cover;
    }

    .field-number {
        width: 60px;
    }

    .field-edit {
        width: 80px;
    }

    .table-svg-button {
        cursor: pointer;
        user-select: none;
        color: #999999;
    }

    .table-svg-delete {
        width: 25px;
        height: 25px;
    }

    .table-svg-button:hover {
        color: #626262;
    }

    .table-svg-button:active {
        color: #303030;
    }

    table {
        border-collapse: collapse;
        table-layout: fixed;
        height: 100% !important;
        width: 100%;
        color: #626262;
        background-color: white;
        /*font-size: 20px;*/
        box-sizing: border-box;
    }

    th, td {
        padding: 8px;
        text-align: center;
        border-bottom: 1px solid #ddd;
    }

    .body-tr:hover {
        background-color: #E9E9E9;
    }
</style>
